import { Box } from "@mui/material";
import { styled } from "@mui/system";
import xMask from "../../../../assets/images/hero-x.svg";

export const StyleWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "100dvh",
  minHeight: "640px",
  overflow: "hidden",
  marginTop: "100px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "50px",
    minHeight: "560px",
  },
  ".hero-video": {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0,
  },
  ".hero-red-rect": {
    position: "absolute",
    inset: 0,
    backgroundColor: theme.palette.primary.main,
    mixBlendMode: "multiply",
    pointerEvents: "none",
    zIndex: 1,
  },
  ".hero-red-x": {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "-12%",
    height: "100%",
    width: "auto",
    aspectRatio: "972 / 743",
    backgroundColor: theme.palette.primary.main,
    WebkitMaskImage: `url(${xMask})`,
    maskImage: `url(${xMask})`,
    WebkitMaskSize: "100% 100%",
    maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    mixBlendMode: "overlay",
    pointerEvents: "none",
    zIndex: 2,
    "@media (orientation: portrait)": {
      display: "none",
    },
  },
}));
